import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import BarcodeDisplay from './barcode-display';
import './barcode-page.scss';

interface BarcodePageState {
    barcodeValue: string;
    quantity: number;
    barcodeWidth: number;
    barcodeHeight: number;
}

interface LocationState {
    barcodeValue?: string;
}

class BarcodePage extends Component<RouteComponentProps<{}, {}, LocationState>, BarcodePageState> {
    private printTimeoutId?: number;

    constructor(props: RouteComponentProps<{}, {}, LocationState>) {
        super(props);
        
        const locationState = this.props.location.state;
        
        this.state = {
            barcodeValue: locationState?.barcodeValue || '',
            quantity: 24,
            barcodeWidth: 244,
            barcodeHeight: 122
        };
    }

    componentDidMount() {
        // Automatically trigger print dialog after barcodes are rendered
        if (this.state.barcodeValue) {
            this.printTimeoutId = window.setTimeout(() => {
                window.print();
            }, 500);
        }
    }

    componentWillUnmount() {
        if (this.printTimeoutId) {
            clearTimeout(this.printTimeoutId);
        }
    }

    renderBarcodes = () => {
        const barcodes = [];
        const { quantity, barcodeValue, barcodeWidth, barcodeHeight } = this.state;
        
        for (let i = 0; i < quantity; i++) {
            barcodes.push(
                <div 
                    key={i} 
                    className="barcode-item"
                    style={{ width: `${barcodeWidth}px`, height: `${barcodeHeight}px` }}
                >
                    <div className="barcode-content">
                        <BarcodeDisplay 
                            value={barcodeValue}
                            width={2}
                            height={60}
                            fontSize={14}
                        />
                    </div>
                </div>
            );
        }
        return barcodes;
    };

    render() {
        return (
            <div className="barcode-page-container">
                <div className="barcode-grid-container">
                    <div className="barcode-grid">
                        {this.renderBarcodes()}
                    </div>
                </div>
            </div>
        );
    }
}

export default BarcodePage;

